import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../core/settings.service';
import {Cookie} from '../helper/cookie';
import * as SpecialOfferActions from './store/special-offer.actions';

@Injectable({
  providedIn: 'root'
})
export class SpecialOfferService {

  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService
  ) { }

  getSpecialOfferActive() {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'special/offer/active',
      {
        params: {

        }
      }
    );
  }

  useSpecialOffer(id: number) {
    const cookies = new Cookie();
    const refCode = cookies.getCookie('ref_code');

    const body = {
      id: id
    };

    if (refCode !== undefined) {
      body['refCode'] = refCode;
    }

    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'special/offer/' + id.toString() + '/payment/stripe',
      body
    );
  }

  checkSpecialOfferCloseState(id: number): boolean {
    const localStorageKey = SpecialOfferActions.LOCAL_STORAGE_KEY;
    let specialOfferCloseState: any = localStorage.getItem(localStorageKey);
    if (specialOfferCloseState === null) {
      return false;
    }

    specialOfferCloseState = JSON.parse(specialOfferCloseState);
    if (specialOfferCloseState[id] === undefined) {
      return false;
    }

    return specialOfferCloseState[id];
  }

  setSpecialOfferCloseState(id: number, value: boolean) {
    const localStorageKey = SpecialOfferActions.LOCAL_STORAGE_KEY;
    let specialOfferCloseState: any = localStorage.getItem(localStorageKey);
    if (specialOfferCloseState === null) {
      specialOfferCloseState = {};
    } else {
      specialOfferCloseState = JSON.parse(specialOfferCloseState);
    }
    specialOfferCloseState[id] = value;
    localStorage.setItem(localStorageKey, JSON.stringify(specialOfferCloseState));
  }


}
